import { render, staticRenderFns } from "./ecosystem-page.vue?vue&type=template&id=11d68056&scoped=true"
import script from "./ecosystem-page.vue?vue&type=script&lang=js"
export * from "./ecosystem-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d68056",
  null
  
)

export default component.exports